import './simple-title.scss';